export default (_theme) => ({
  root: {
    // Trick to get bits inside the system
    // to have no margin-bottom (bits have margin-bottom set)
    '& > div > div': {
      marginBottom: 0,
    },
    marginBottom: 16,
  },
});
